// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","terms":"styles_terms__+YLze","agreement":"styles_agreement__kxAcN","form":"styles_form__-tLJN"};